import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Button,
  DatePicker,
  InputNumber,
  Input,
  Tooltip,
} from "antd";
import { updateDataEntryForm } from "../../actions/user";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import OrganizationListing from "../../components/Comman/DropdownsListing/OrganizationListing";
import DataElementsListing from "../../components/Comman/DropdownsListing/DataElementsListing";
import { createDataEntryForm } from "../../actions/user";
import { Rule } from "antd/lib/form";

const { Option } = Select;

interface SideDrawerProps {
  dataElementData?: any; // Optional organization data
  open?: boolean;
  onClose?: any;
  apiType?: string;
}

const DataEntryModel: React.FC<SideDrawerProps> = ({
  dataElementData,
  open,
  onClose,
  apiType,
}) => {
  const [form] = Form.useForm();
  const user = useSelector((state: any) => state?.Auth?.user);
  const roleId = user?.user?.roleId;
  const dispatch: any = useDispatch();
  const loadingGlobal = useSelector((state: any) => state?.General);
  const [budgetDescription, setBudgetDescription] = useState(null);
  const [selectedOrgId, setSelectedOrgId] = useState(null); // Add this state
  const [hasDataElement, setHasDataElement] = useState(false);
  const [intervalId, setIntervalId] = useState([]);
  const [dataElementId, setDataElementId] = useState(null);
  const [valueType, setValueType] = useState(null);

  const inputValidation = {
    // Validate keydown events for different input types
    handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, type: string) => {
      const target = e.target as HTMLInputElement;
      const value = target.value;
      const selectionStart = target.selectionStart || 0;
      const selectionEnd = target.selectionEnd || 0;
      const hasSelection = selectionStart !== selectionEnd;

      // Control keys that are always allowed
      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      // Check if pressed key is a control key
      if (controlKeys.includes(e.key)) {
        return;
      }

      // For integer inputs, only allow digits
      if (type === "Integer" && !/^\d$/.test(e.key)) {
        e.preventDefault();
        return;
      }

      // For decimal inputs (Money and Decimal)
      if (["Money", "Decimal"].includes(type)) {
        // Only allow digits and decimal point
        if (!/^\d$/.test(e.key) && e.key !== ".") {
          e.preventDefault();
          return;
        }

        // Prevent multiple decimal points
        if (e.key === "." && value.includes(".")) {
          e.preventDefault();
          return;
        }

        // Check for decimal place limit (only for Money type)
        if (type === "Money" && /^\d$/.test(e.key) && value.includes(".")) {
          const parts = value.split(".");

          // If selection spans across decimal point, allow typing
          if (
            hasSelection &&
            selectionStart <= value.indexOf(".") &&
            selectionEnd > value.indexOf(".")
          ) {
            return;
          }

          // If cursor is after decimal and already 2 decimal places
          if (
            parts[1] &&
            parts[1].length >= 2 &&
            selectionStart > value.indexOf(".")
          ) {
            // Allow if there's a selection after decimal point (for replacement)
            if (hasSelection && selectionStart > value.indexOf(".")) {
              return;
            }
            e.preventDefault();
          }
        }
      }
    },

    // Format and sanitize input values
    formatValue: (value: string, type: string): string => {
      if (!value) return "";

      // Base pattern to keep only digits and decimal point
      let result = value.replace(/[^\d.]/g, "");

      // Handle multiple decimal points (keep only the first one)
      const parts = result.split(".");
      if (parts.length > 2) {
        result = parts[0] + "." + parts.slice(1).join("");
      }

      // For integer values, remove any decimal part
      if (type === "Integer") {
        result = parts[0];
      }

      // For Money type, limit to 2 decimal places
      if (type === "Money" && parts.length === 2 && parts[1].length > 2) {
        result = parts[0] + "." + parts[1].substring(0, 2);
      }

      return result;
    },
  };

  useEffect(() => {
    if (!open) {
      form.resetFields();
      setHasDataElement(false);
      setDataElementId(null);
      // setLogoUrl(null);
    }
  }, [open]);

  const handleFormValuesChange = (changedValues) => {
    // Check if Organization_ID changed
    if ("Organization_ID" in changedValues) {
      const orgId = changedValues.Organization_ID;
      setSelectedOrgId(orgId);
      form.setFieldValue("DataElements_ID", null);
    }
    // Check if DataElements_ID changed
    // Check if DataElements_ID changed
    if ("DataElements_ID" in changedValues) {
      setDataElementId(changedValues.DataElements_ID);
      form.setFieldValue(
        "SubmissionData_Period",
        changedValues.DataElements_ID
      );
      // Simple check if the value exists and is not null/undefined/empty string/zero
      setHasDataElement(true);
    }
  };

  const onFinish = async (values: any) => {
    delete values.SubmissionData_Period;
    // Console log the form values first
    values.SubmissionData_Year =
      typeof values.SubmissionData_Year === "number"
        ? values.SubmissionData_Year.toString()
        : values?.SubmissionData_Year
        ? dayjs(values.SubmissionData_Year).format("YYYY")
        : undefined;
    if (dataElementData?.id) {
      // const payload = { ...values, budgetId: dataElementData?.id };
      const payload = {
        SubmissionData_Value: values.SubmissionData_Value,
        id: dataElementData?.id,
        roleId,
      };
      dispatch(
        updateDataEntryForm(payload, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields(); // Clear form on successful submission
            onClose();
          }
        })
      );
    } else {
      dispatch(
        createDataEntryForm(values, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields(); // Clear form on successful submission
            onClose();
          }
        })
      );
    }
  };

  useEffect(() => {
    const getDataInterval = intervalId?.find(
      (data) => data?.id === dataElementId
    );
    setValueType(getDataInterval?.DataElements_DataType);
    const intervalValue = getDataInterval?.interval?.id;
    if (intervalValue) {
      form.setFieldValue(
        "SubmissionData_Period",
        getDataInterval?.interval?.Interval_Name
      );
    }
  }, [intervalId, dataElementId, open]);



  useEffect(() => {
    if (dataElementData) {
      // setValueType(dataElementData?.dataElement?.DataElements_DataType);
      form.setFieldsValue({
        Organization_ID: dataElementData?.organization?.name || "",
        DataElements_ID: dataElementData?.DataElements_ID || "",
        linkedDataElement:
          dataElementData?.dataElement?.DataElements_Name || "",
        SubmissionData_Year: dataElementData?.SubmissionData_Year
          ? dayjs(`${dataElementData.SubmissionData_Year}-01-01`) // Treat as YYYY-MM-DD
          : "",
        SubmissionData_Period:
          dataElementData?.dataElement?.DataElements_DataType,
        SubmissionData_Value: dataElementData?.SubmissionData_Value || "",
      });
    } else {
      form.resetFields();
    }
  }, [dataElementData, form, open]);

  const getValidationRules = (): Rule[] => {
    const baseRules: Rule[] = [
      { required: true, message: "Please enter a value" },
    ];

    switch (valueType) {
      case "Money":
        return [
          ...baseRules,
          {
            type: "number" as const, // Use 'as const' to make TypeScript treat this as a literal type
            message: "Please enter a valid monetary value",
            transform: (value) => Number(value),
          },
        ];
      case "Integer":
        return [
          ...baseRules,
          {
            type: "integer" as const,
            message: "Only whole numbers are allowed",
            transform: (value) => Number(value),
          },
          {
            validator: async (_, value) => {
              if (value !== undefined && !Number.isInteger(Number(value))) {
                return Promise.reject(new Error("Please enter a whole number"));
              }
              return Promise.resolve();
            },
          },
        ];
      case "Decimal":
        return [
          ...baseRules,
          {
            type: "number" as const,
            message: "Please enter a valid decimal number",
            transform: (value) => Number(value),
          },
        ];
      default:
        return [
          ...baseRules,
          {
            type: "number" as const,
            message: "Only numbers are allowed",
            transform: (value) => Number(value),
          },
        ];
    }
  };

  // Render the appropriate input field based on value type
  const renderValueInput = (valueType) => {
    if (dataElementData) {
      valueType = dataElementData?.dataElement?.DataElements_DataType;
    }
    const commonClassName =
      "input-main-col  focus:bg-transparent rounded-[5px] mb-[10px] ps-[18px] pe-[12px] py-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#fff] text-white h-auto";
    const commonClassPerName =
      "input-main-col  focus:bg-transparent rounded-[5px] mb-[10px] px-[10px]  py-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#fff] text-white h-auto";

    switch (valueType) {
      case "Money":
        return (
          <Input
            prefix={<span className="mt-[1px] inline-block text-white">$</span>}
            placeholder="Enter Value"
            className={commonClassName}
            onKeyDown={(e) => inputValidation.handleKeyDown(e, "Money")}
            onChange={(e) => {
              e.target.value = inputValidation.formatValue(
                e.target.value,
                "Money"
              );
            }}
          />
        );
      case "Integer":
        return (
          <InputNumber
            placeholder="Enter Value"
            className={`input-multi-number ${commonClassPerName}`}
            min={0}
            precision={0} // No decimal places for integers
            stringMode // To avoid scientific notation
            controls={false}
            step={1}
            parser={(value: any) => {
              // Remove all non-digit characters including decimal points
              return value ? value.replace(/[^\d]/g, "") : "";
            }}
            formatter={(value) => {
              // Ensure the displayed value is also integer-only
              return value ? value.replace(/[^\d]/g, "") : "";
            }}
            onKeyPress={(e) => {
              // Prevent decimal point and other non-digit characters from being typed
              if (
                !/^\d$/.test(e.key) &&
                ![
                  "Backspace",
                  "Delete",
                  "Tab",
                  "Enter",
                  "ArrowLeft",
                  "ArrowRight",
                ].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
          />
        );
      case "Decimal":
        return (
          <InputNumber
            placeholder="Enter Value"
            className={`input-multi-number ${commonClassPerName}`}
            min={0}
            step="0.01" // Allow decimal steps
            stringMode // To avoid scientific notation
            controls={false}
          />
        );
      case "Percent":
        return (
          <InputNumber
            suffix="%"
            placeholder="Enter Value"
            className={`input-multi-number ${commonClassName}`}
            min={0}
            step="0.01" // Allow decimal steps
            stringMode // To avoid scientific notation
            controls={false}
          />
        );
      default:
        return (
          <InputNumber
            placeholder="Enter Value"
            className={`input-multi-number ${commonClassName}`}
            min={0}
          />
        );
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      onValuesChange={handleFormValuesChange}
    >
      {dataElementData?.id ? (
        <div>
          <div className="mb-[10px]">
            <Tooltip title="Contact email">
              <Form.Item name="Organization_ID">
                <Input
                  type="text"
                  placeholder="Enter Organization"
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[12px] 2xl:p-[15px] 2xl:px-[17px]  border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff]"
                  disabled
                />
              </Form.Item>
            </Tooltip>
          </div>
        </div>
      ) : (
        <div>
          <OrganizationListing
            dataToSet={dataElementData}
            pageName={dataElementData?.id ? "editDataEntry" : "dataEntry"}
            keyName={"Organization_ID"}
            idType={"dataEntry"}
          />
        </div>
      )}

      {dataElementData?.DataElements_ID ? (
        <div className="mb-[10px]">
          <Form.Item name="linkedDataElement">
            <InputNumber
              placeholder="Enter Value"
              className="input-main-col input-multi-number focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#fff] text-white h-auto"
              min={0} // Ensures only positive integers (optional)
              disabled
            />
          </Form.Item>
        </div>
      ) : (
        <div>
          <DataElementsListing
            dataToSet={dataElementData}
            keyName={"DataElements_ID"}
            name={dataElementData?.id ? "editDataEntry" : "dataEntry"}
            setBudgetDescription={setBudgetDescription}
            selectedOrgId={selectedOrgId}
            setIntervalId={setIntervalId}
            apiType={"user"}
          />
        </div>
      )}
      {hasDataElement || dataElementData?.id ? (
        <>
          <div className="mb-[10px]">
            <Form.Item
              name="SubmissionData_Year"
              initialValue={dayjs()} // Set default value to current year
              rules={[{ required: true, message: "Please select a date" }]}
            >
              <DatePicker
                placeholder="Submission Year"
                className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] px-[20px] py-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
                picker="year"
                // onChange={handleDateChange}
                disabledDate={(current) => {
                  return current && current > dayjs().endOf("year"); // Disable future years
                }}
                // disabled={!!dataElementData?.id} // Disable when dataElementData.id exists
                disabled
              />
            </Form.Item>
          </div>

          <div className="mb-[10px]">
            <Form.Item
              name="SubmissionData_Period"
              rules={[
                {
                  required: true,
                  message: "Please select a submission period",
                },
              ]}
            >
              <Select
                placeholder="Submission Period"
                className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] color-[#fff] h-auto"
                disabled={true}
              >
                {form.getFieldValue("SubmissionData_Period") && (
                  <Option value={form.getFieldValue("SubmissionData_Period")}>
                    {form.getFieldValue("SubmissionData_Period")}
                  </Option>
                )}
              </Select>
            </Form.Item>
          </div>
          <div className="mb-[10px]">
            <Form.Item name="SubmissionData_Value" rules={getValidationRules()}>
              {renderValueInput(valueType)}
            </Form.Item>
          </div>
        </>
      ) : (
        <p>
          Related information will only be displayed after you select a data
          element{" "}
        </p>
      )}
      <div className="mb-[20px]">
        <Form.Item>
          <Button
            htmlType="submit"
            className="p-[25px] text-[12px] w-full text-white rounded-md gradient-button"
            loading={loadingGlobal?.isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default DataEntryModel;
